// extracted by mini-css-extract-plugin
module.exports = {"Form":"UserSignUp_Form__2J52E","Header":"UserSignUp_Header__2FRMd","Label":"UserSignUp_Label__ZjikH","Input":"UserSignUp_Input__GXVEn","Button":"UserSignUp_Button__JLVbJ"};